import React from 'react';
import Grid from "@material-ui/core/Grid";
import { Card, CardContent, createStyles, makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {},
        card: {
            margin: 5,
        },
        title: {
            fontSize: 14
        },
        pos: {
            marginBottom: 1,
        },
        avatar: {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.getContrastText(theme.palette.primary.light)
        }
    });
});
function formatValueAsKilo(val) {
    return (val / 1000).toFixed(2);
}
function formatEnergyForDate(device, date) {
    var result = "--";
    if (device.energy) {
        var energy = device.energy[date];
        if (energy && !Number.isNaN(energy))
            result = formatValueAsKilo(energy) + " kWh";
    }
    return result;
}
function formatPower(val) {
    return formatValueAsKilo(val) + " kW";
}
export function DeviceDetails(_a) {
    var device = _a.device;
    var classes = useStyles();
    var todayString = moment().format('YYYY-MM-DD');
    var yesterdayString = moment().subtract(1, "day").format('YYYY-MM-DD');
    var todayEnergyString = formatEnergyForDate(device, todayString);
    var yesterdayEnergyString = formatEnergyForDate(device, yesterdayString);
    return (React.createElement(Card, { className: classes.card },
        React.createElement(CardHeader, { avatar: React.createElement(Avatar, { className: classes.avatar }, device.name.substr(0, 1)), title: device.name, subheader: device.type + " - " + device.serialNumber }),
        React.createElement(CardContent, null,
            React.createElement(Grid, { container: true, direction: "row", justify: "center", alignItems: "center", className: classes.root },
                device.firmwareVersion ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: 8, lg: 5, zeroMinWidth: true },
                            React.createElement(Typography, { className: classes.title, color: "textPrimary", noWrap: true }, "Firmware:")),
                        React.createElement(Grid, { item: true, xs: 4, lg: 5, zeroMinWidth: true },
                            React.createElement(Typography, { className: classes.title, color: "textPrimary", noWrap: true }, device.firmwareVersion)))
                    :
                        React.createElement(React.Fragment, null),
                React.createElement(Grid, { item: true, xs: 8, lg: 5 },
                    React.createElement(Tooltip, { title: "Energy consumption Yesterday" },
                        React.createElement(Typography, { className: classes.title, color: "textSecondary", noWrap: true }, "Energy consumption Yesterday:"))),
                React.createElement(Grid, { item: true, xs: 4, lg: 5 },
                    React.createElement(Tooltip, { title: yesterdayEnergyString },
                        React.createElement(Typography, { className: classes.title, color: "textSecondary" }, yesterdayEnergyString))),
                React.createElement(Grid, { item: true, xs: 8, lg: 5 },
                    React.createElement(Tooltip, { title: "Energy consumption Today" },
                        React.createElement(Typography, { className: classes.title, color: "textPrimary", noWrap: true }, "Energy consumption Today:"))),
                React.createElement(Grid, { item: true, xs: 4, lg: 5 },
                    React.createElement(Tooltip, { title: todayEnergyString },
                        React.createElement(Typography, { className: classes.title, color: "textPrimary" }, todayEnergyString))),
                device.peekPower ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: 8, lg: 5 },
                            React.createElement(Tooltip, { title: "Energy consumption Today" },
                                React.createElement(Typography, { className: classes.title, color: "textPrimary", noWrap: true }, "Peek Power Today:"))),
                        React.createElement(Grid, { item: true, xs: 4, lg: 5 },
                            React.createElement(Tooltip, { title: todayEnergyString },
                                React.createElement(Typography, { className: classes.title, color: "textPrimary" }, formatPower(device.peekPower)))))
                    :
                        React.createElement(React.Fragment, null)))));
}
//# sourceMappingURL=DeviceDetails.js.map